import { Typography } from '@mui/material'
import colors from '@theme/colors'
import styled from 'styled-components'

export const MyMessage = styled(Typography)`
  text-align: right;
  background-color: ${colors['$color-background-tertiary']};
  padding: 0px 20px;
  border-radius: 16px;
  z-index: 999;
`

export const BotMessage = styled(Typography)`
  text-align: left;
  padding: 0;
  padding-right: 10px;
  margin: 0 !important;
  p {
    padding: 0;
    margin: 0 !important;
  }
  z-index: 999;
`

export const MessageStack = styled.div`
  --cmui-gap-size: 0.5rem;
  --cmui-block-spacing: 0.5rem;

  display: flex;
  gap: var(--cmui-gap-size);
  padding-inline: var(--cmui-inline-spacing);
  padding-block: var(--cmui-block-spacing);
`

export const MyMessageStack = styled(MessageStack)`
  flex-direction: row-reverse;
  margin-right: 4px;
`

export const BotMessageStack = styled(MessageStack)`
  flex-direction: column;
`

export const BotImage = styled.img`
  background-color: ${colors['$color-action-background-primary-default']};
  padding: 6px;
  border-radius: 4px;
  margin: 0px 16px 0px 0px;
`
